PegasusTemplate.ModalMixin = Ember.Mixin.create({
  classNames: ['modal'],
  modal: this,
  backdrop: 'static',
  keyboard: false,
  draggable: false,

  didInsertElement: function() {
    if( !this.get('presenter') ){ return; }
    var width = this.get('width');

    //this.$().modal({
      //show: true,
      //backdrop: this.get('backdrop'),
      //keyboard: this.get('keyboard')
    //});

    if (width) {
      this.$().width(width);
    }

    //if (this.get('draggable')) {
      //this.$().draggable({ handle:'.modal-header' });
    //}
  },

  becameHidden: function(){
    var backdrop = $( '.modal-backdrop' );
    if( this.get('backdrop') ){ backdrop.remove(); }
    this._super.apply( this, arguments );
  }
});
